import { useAppSelector } from '@/shared/hooks';

import { reportsModel } from '@/entities/reports';

import { resolveServerToothSliceOptions } from '../lib';

export const useToothSliceOptions = ({
  thicknessOptionsMm,
  toothID,
}: {
  thicknessOptionsMm: number[];
  toothID: string;
}) => {
  const options = useAppSelector(
    reportsModel.selectors.selectMPRSliceOptionsByToothID(toothID),
  );

  const sliceOptions = resolveServerToothSliceOptions({
    proto: options,
    thicknessOptionsMm,
  });

  return { sliceOptions };
};
